import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

import { AuthenticationService } from '@core/services/authentication.service';
import { PropertiesService } from '@core/services/properties.service';
import { UserService } from '@core/services/user.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(
    private authenticationService: AuthenticationService,
    private propertiesService: PropertiesService,
    private userService: UserService) {
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

    if (this.authenticationService.hasToken()) {
      if (!this.userService.activeUser.passwordChanged) {
        this.authenticationService.goTo('/password-change');
      }
      return true;
    } else if (this.propertiesService.PLAYGROUND) {
      this.authenticationService.goTo('/playground-register');
    }
    else {
      this.authenticationService.goTo('/login');
    }
  }
}
